import { apiPost, apiPut, apiGet } from './api'

export const createClientSecret = (body) => {
  return apiPost('api/v1/payments/reimbursement/init', body)
}

export const completePaymentMethod = (body) => {
  return apiPost('api/v1/payments/reimbursement/complete', body)
}
export const paymentSetUpIntent = (body) => {
  return apiPost('api/v1/payments/reimbursement/setup-intent', body)
}
export const cancelSubscription = (ref, body) => {
  return apiPut(`api/v1/reimbursement-accounts/me/subscriptions/${ref}/cancel`, body)
}
export const reActivateSubscription = (body) => {
  return apiPost('api/v1/reimbursement-accounts/me/subscriptions/activate', body)
}
export const paymentSetUpIntentSubscription = (paymentMethodUpdate) => {
  return apiGet(
    `api/v1/reimbursement-accounts/me/subscriptions/setup-intent?paymentMethodUpdate=${paymentMethodUpdate}`,
  )
}
export const updatePaymentMethod = (body) => {
  return apiPut('api/v1/reimbursement-accounts/me/payment-methods', body)
}
